import React from 'react'

const OneBookPage = () => {
  return (
    <div>One Book Page</div>
  )
}

export default OneBookPage